<div class="px-8 md:px-16 lg:px-64 hero">
    <h1 class="text-3xl md:text-5xl leading-snug">
        <span class="block">La nostra stagione.</span>
        <span class="block">Un anno di spettacoli</span>
        <span class="relative quote">e concerti.</span>
    </h1>
</div>

<section class="mb-8 px-container py-16" #stagione>
    <div class="flex lg:flex-row flex-col justify-between lg:gap-0 gap-8 mb-8 lg:mb-16 w-full">
        <span class="block p-input-icon-left w-full lg:w-1/3">
            <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
            <input type="text" [(ngModel)]="ricerca" pInputText placeholder="CERCA" class="bg-light rounded-3xl w-full indent-6" (ngModelChange)="onCerca($event)" />
        </span>
        <div class="flex flex-wrap justify-end gap-4 lg:w-2/3 w-full buttons">
            <button type="button" class="grow-0 layoutButton" [ngClass]="{'bg-accent border-accent': all, 'bg-light': !all}" (click)="onAll()"><i class="text-xl bi" [ngClass]="{'bi-eye-slash': all, 'bi-eye': !all}"></i>TUTTI</button>
            <button type="button" class="grow-0 layoutButton" [ngClass]="{'bg-accent border-accent': card, 'bg-light': !card}" (click)="card = true"><i class="bi-grid text-xl bi"></i>CARD</button>
            <button type="button" class="grow-0 layoutButton" [ngClass]="{'bg-accent border-accent': !card, 'bg-light': card}" (click)="card = false"><i class="text-xl bi bi-list"></i>LISTA</button>
            <a [href]="(conf_stagione?.programma || '' | pdf)" target="_blank" target="_blank" class="layoutButton bg-light grow-0 uppercase">scarica il programma</a>
        </div>
    </div>
    
    <ng-container *ngIf="spettacoli_paginazione.length > 0">
        <div class="grid md:grid-cols-2 lg:grid-cols-3" *ngIf="card">
            <div *ngFor="let spettacolo of spettacoli_paginazione; let i = index">
                <app-box-stagione [spettacolo]="spettacolo" class="flex border-e-2 border-gray-300 lg:border-e-0 border-b-2 border-l-2 border-dashed h-full" [ngClass]="{'lg:!border-e-2': (i + 1) % 3 === 0, 'lg:border-t-2': (i + 1) <= 3, 'border-t-2': i == 0, '!border-e-2': spettacoli_paginazione.length == (i + 1), 'md:border-t-2': (i + 1) <= 2, 'lg:border-l-2 md:border-l-0': i % 2 != 0, 'bordo': (i + 1) > 3 && (i + 1) % 3 !== 0}"></app-box-stagione>
            </div>
        </div>
        <div class="divide-y-2 divide-dashed divide-gray-300" id="lista" *ngIf="!card">
            <div class="bubble" id="bubble" ></div>
            <div *ngFor="let spettacolo of spettacoli_paginazione;" (mouseover)="setBubbleImage(spettacolo.img_box)" class="hover:bg-dark hover:text-light duration-300 spettacolo-list">
                <app-box-stagione [card]="card" [spettacolo]="spettacolo"></app-box-stagione>
            </div>
        </div>
    </ng-container>    

    <div class="text-center no-result" *ngIf="spettacoli_paginazione.length === 0 && !caricamento">
        <h1 class="font-medium text-xl lg:text-2xl">Nessuno spettacolo in programma...</h1>
    </div>

    <div class="mt-20 paginator" *ngIf="spettacoli_filtrati.length >= 12">
        <p-paginator (onPageChange)="onPageChange($event, stagione)" [first]="pagina" [rows]="12" [totalRecords]="spettacoli_filtrati.length" [showJumpToPageDropdown]="false" />
    </div>
</section>